import { observer } from "mobx-react";
import { useI18n } from "@/stores/RootStoreContext";
import { Select, SelectProps } from "./Select";
import { changeLanguageAction } from "@/i18n/i18nDomain";
import { Language, languageLabel } from "@/i18n/languages";

export const LanguageSelector = observer((props: Partial<SelectProps<Language>>) => {
  const { lang } = useI18n();
  return (
    <Select
      {...props}
      items={Object.values(Language)}
      value={lang}
      onSelect={changeLanguageAction}
      idFn={String}
      labelFn={languageLabel}
    />
  );
});
